<template>
  <div
    class="paiban-img"
    v-loading="isLoading"
    :element-loading-text="$translateLang(loadingText)"
  >
    <breadcrumb
      :title="$route.query.line || $translateLang('排版方案')"
      :childTitle="$translateLang('排版图管理')"
      @goBackPage="$router.push({ path: '/newPaiban' })"
      class="breadcrumb-box"
    >
    </breadcrumb>
    <div class="custom-btn">
      <span class="title ml14 mr10">{{ $translateLang('自定义排版图') }}</span>
      <a-switch
        id="paiban-img-custom-switch"
        v-model="isCustomPaibanImg"
        @change="handleChangeCustom"
      ></a-switch>
    </div>

    <div class="paiban-img-content" v-show="isCustomPaibanImg">
      <div class="left">
        <div class="template">
          <div class="flex flex-main--justify">
            <span
              class="title ellipsis"
              :title="$translateLang('排版图模板')"
              >{{ $translateLang('排版图模板') }}</span
            ><span
              class="add-tem ellipsis"
              :title="$translateLang('添加模板')"
              id="paiban-img-add-template-btn"
              @click="handleAddTem"
              >{{ $translateLang('添加模板') }}</span
            >
          </div>
          <div class="template-list" v-loading="isLoadTem">
            <div
              v-for="(item, index) in templateList"
              :key="`template_${index}`"
              class="item"
              :class="{ 'active-item': activeTemId === item.id }"
              :id="`paiban-img-select-tempalte-option-${index}`"
              @click="handleSelectedTem(item)"
            >
              <div class="flex">
                <a-checkbox
                  :checked="item.status === 1"
                  :id="`paiban-img-select-tempalte-option-${index}-checkbox`"
                  @change.stop="handleCheckedTem($event, item)"
                  @click.stop
                ></a-checkbox>
                <span
                  class="name"
                  :title="item.name.length > 16 ? item.name : ''"
                  >{{ item.name }}</span
                >
              </div>
              <div v-show="activeTemId === item.id && item.is_default !== 1">
                <i
                  class="iconfont icon-trash-copy mr16"
                  :id="`paiban-img-select-tempalte-option-${index}-delete`"
                  @click="handleShowDelModal(item)"
                ></i>
                <i
                  class="iconfont icon-fankui"
                  :id="`paiban-img-select-tempalte-option-${index}-edit`"
                  @click.stop="gotoEdit(item)"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="setting-search">
          <span class="title">{{ $translateLang('板件筛选') }}</span>
          <div class="setting-search-item">
            <span class="title">{{ $translateLang('大板序号搜索') }}</span>
            <a-input
              class="mt8"
              v-model="canvasIndex"
              style="width: 249px"
              :disabled="
                matCode != '全部' ||
                texture != '全部' ||
                thick != '全部' ||
                !!minSize ||
                !!maxSize
              "
              @input="handleInputNumber('canvasIndex')"
              id="paiban-img-seatch-input"
              @blur="handleSearch"
            ></a-input>
          </div>
          <div class="setting-search-item">
            <span class="title">{{ $translateLang('材质') }}</span>
            <a-select
              v-model="matCode"
              class="mt8"
              style="width: 249px"
              :disabled="!!canvasIndex"
              id="paiban-img-matCode-select"
              @change="handleSearch"
            >
              <a-select-option
                v-for="(item, idx) in matCodeOptions"
                :key="`paibanImg_matCode_select_${item}`"
                :id="`paiban-img-matCode-select-option-${idx}`"
                :value="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </div>
          <div class="setting-search-item">
            <span class="title">{{ $translateLang('颜色') }}</span>
            <a-select
              v-model="texture"
              class="mt8"
              style="width: 249px"
              :disabled="!!canvasIndex"
              id="paiban-img-color-select"
              @change="handleSearch"
            >
              <a-select-option
                v-for="(item, idx) in textureOptions"
                :key="`paibanImg_texture_select_${item}`"
                :id="`paiban-img-color-select-option-${idx}`"
                :value="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </div>
          <div class="setting-search-item">
            <span class="title">{{ $translateLang('厚度') }}</span>
            <a-select
              v-model="thick"
              class="mt8"
              style="width: 249px"
              :disabled="!!canvasIndex"
              id="paiban-img-thick-select"
              @change="handleSearch"
            >
              <a-select-option
                v-for="(item, idx) in thickOptions"
                :key="`paibanImg_thick_select_${item}`"
                :id="`paiban-img-thick-select-option-${idx}`"
                :value="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </div>
          <div class="setting-search-item">
            <span class="title">{{ $translateLang('板件尺寸') }}</span>
            <div class="mt8">
              <a-input
                v-model="minSize"
                style="width: 104px"
                :placeholder="$translateLang('板材宽度')"
                :disabled="!!canvasIndex"
                id="paiban-img-width-input"
                @input="handleInputSize('minSize')"
                @blur="handleSearch"
              ></a-input>
              <span class="line">--</span>
              <a-input
                v-model="maxSize"
                style="width: 104px"
                :placeholder="$translateLang('板材长度')"
                id="paiban-img-height-input"
                :disabled="!!canvasIndex"
                @input="handleInputSize('maxSize')"
                @blur="handleSearch"
              ></a-input>
            </div>
          </div>
        </div>
        <div class="setting-other">
          <div
            class="title ellipsis"
            :title="$translateLang('排版图序号自动补偿到')"
          >
            {{ $translateLang('排版图序号自动补偿到') }}：
          </div>
          <a-input-number
            class="mt12"
            style="width: 104px"
            :min="1"
            :max="99"
            id="paiban-img-auto-offset-input"
            v-model="numAutoOffset"
            @blur="handleChangeNumAutoOffset"
          ></a-input-number>
          <span class="title ml10">{{ $translateLang('位') }}</span>
          <div
            class="title mt16 mb12 ellipsis"
            :title="$translateLang('打印一张纸最多展示')"
          >
            {{ $translateLang('打印一张纸最多展示') }}：
          </div>
          <div class="flex flex-cross--center">
            <a-input
              style="width: 104px"
              v-model="onePageNum"
              id="paiban-img-one-page-input"
              @blur="handleChangeOnePageNum"
              @input="handleInputNumber('onePageNum')"
            ></a-input>
            <span
              class="title ml10 ellipsis"
              style="max-width: 120px"
              :title="$translateLang('张排版图')"
              >{{ $translateLang('张排版图') }}</span
            >
          </div>
        </div>
      </div>
      <div class="right">
        <div class="head">
          <a-popover placement="bottom" overlayClassName="paiban-img-symbol">
            <template #content>
              <div class="symbol-item">
                <span class="slot-img"></span
                ><span class="ellipsis" :title="$translateLang('正面槽')">{{
                  $translateLang('正面槽')
                }}</span>
              </div>
              <div class="symbol-item">
                <span class="slot-img back"></span
                ><span class="ellipsis" :title="$translateLang('反面槽')">{{
                  $translateLang('反面槽')
                }}</span>
              </div>
              <div class="symbol-item">
                <span class="hole-img"></span
                ><span class="ellipsis" :title="$translateLang('正面孔')">{{
                  $translateLang('正面孔')
                }}</span>
              </div>
              <div class="symbol-item">
                <span class="hole-img back"></span
                ><span class="ellipsis" :title="$translateLang('反面孔')">{{
                  $translateLang('反面孔')
                }}</span>
              </div>
            </template>
            <span class="symbol" :title="$translateLang('排版图标识')">{{
              $translateLang('排版图标识')
            }}</span>
          </a-popover>
          <a-button
            class="print-btn"
            id="paiban_img_print_btn"
            :disabled="isLoadSvg || !currentPaibanData.length"
            :loading="isExportLoad"
            @click="handlePrint"
            >{{ $translateLang('打印') }}</a-button
          >
          <a-button
            class="export-btn mr16"
            id="paiban_img_export_img_btn"
            :disabled="isLoadSvg || !currentPaibanData.length"
            :loading="isExportLoad"
            @click="handleExport('img')"
            >{{ $translateLang('导出图片') }}</a-button
          >
          <a-button
            class="export-btn mr16"
            id="paiban_img_export_pdf_btn"
            :disabled="isLoadSvg || !currentPaibanData.length"
            :loading="isExportLoad"
            @click="handleExport('pdf')"
            >{{ $translateLang('导出PDF') }}</a-button
          >
          <a-popover
            placement="bottomRight"
            overlayClassName="paiban-img-dxf-export"
          >
            <template #content>
              <div class="dxf-export-options">
                <a-tooltip
                  placement="left"
                  :title="
                    $translateLang('适用于手工加工看图切割或检查排版结果')
                  "
                >
                  <span class="dxf-export-option-wrap">
                    <a-button
                      class="dxf-export-option"
                      id="paiban_img_export_dxf_default_btn"
                      :disabled="isLoadSvg || !currentPaibanData.length"
                      :loading="isExportLoad"
                      @click="handleExportDxf('general-2d-v1')"
                      >{{ $translateLang('二维通用DXF') }}</a-button
                    >
                  </span>
                </a-tooltip>
                <a-tooltip
                  placement="left"
                  :title="
                    $translateLang(
                      '适用于导入三方系统进行生产，已支持辉亚激光切割一体机'
                    )
                  "
                >
                  <span class="dxf-export-option-wrap">
                    <a-button
                      class="dxf-export-option"
                      id="paiban_img_export_dxf_machining_btn"
                      :disabled="isLoadSvg || !currentPaibanData.length"
                      :loading="isExportLoad"
                      @click="handleExportDxf('specialized-3d-v1')"
                      >{{ $translateLang('三维专用DXF') }}</a-button
                    >
                  </span>
                </a-tooltip>
              </div>
            </template>
            <g-paid-feature
              class="dxf-export-trigger mr16"
              :permission-keys="['DXF_2D', 'DXF_3D']"
              :icon-style="{ top: '-10px', right: '-8px' }"
            >
              <a-button
                class="export-btn"
                id="paiban_img_export_dxf_btn"
                :disabled="isLoadSvg || !currentPaibanData.length"
                :loading="isExportLoad"
                >{{ $translateLang('导出DXF') }}</a-button
              >
            </g-paid-feature>
          </a-popover>
        </div>
        <div class="svg-wrap" ref="svgWrap" v-loading="isLoadTem || isLoadSvg">
          <div
            class="svg-scale-container"
            :style="{
              transform: `scale(${zoomScale})`,
              transformOrigin: 'center top',
            }"
          >
            <div
              v-for="(item, index) in svgList.map((item) => item.svg)"
              :key="`paibanImg_svg_${index}`"
              v-html="item"
              class="svg-wrap-item"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除模板弹窗 -->
    <g-base-modal
      :visible="isShowDelModal"
      v-if="isShowDelModal"
      :okText="$translateLang('确认')"
      contain="确认删除该模板？删除后不可恢复"
      @cancel="isShowDelModal = false"
      @ok="handleConfirmDelTem"
    ></g-base-modal>
    <loading
      :loading="isExportLoad"
      :loadingTitle="$translateLang('排版图管理')"
      type="3"
      text="自定义排版图正在下载中"
    ></loading>

    <!-- 切割顺序错误弹窗 -->
    <g-base-modal
      :visible="isShowInspectCutOrder"
      v-if="isShowInspectCutOrder"
      :ok-text="$translateLang('去调整')"
      contain=""
      :isShowCancelBtn="false"
      @ok="handleGoAdjust"
      @cancel="isShowInspectCutOrder = false"
    >
      <div>
        <p>
          {{
            `${$translateLang('检测到您的')}【第
            ${errorBigPlankCutOrders.join('、')}
          张大板】${$translateLang(
            '切割顺序存在错误！请前往排版页调整后再导出排版图文件'
          )}`
          }}
        </p>
      </div>
    </g-base-modal>
  </div>
</template>

<script>
import {
  getCustomFolderSetting,
  getPreferencesSetting,
} from '@/apis/materialList'
import {
  changeModelChecked,
  delModel,
  fetchModelData,
  fetchModelList,
} from '@/apis/paibanImg/index'
import { checkUserPermissions } from '@/auth/user_function'
import loading from '@/components/common/loading'
import GBaseModal from '@/components/g-base-modal.vue'
import GPaidFeature from '@/components/g-paid-feature.vue'
import breadcrumb from '@/components/topBreadCrumb.vue'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { chunkArray } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import {
  defaultPaibanData,
  defaultPaibanImgTemplate,
} from '@/util/defaultTagData'
import { exportPaibanImgDxf } from '@/util/dxf/paibanImgDxf/index'
import { convertJpegToBmp } from '@/util/file/convert'
import { jsPdfTool } from '@/util/tag/pdfFont'
import { initFabricNeedFont } from '@/util/tag/tag-font'
import { getSvgListToPdfJSBinary } from '@/views/printTag/utils/createPdf'
import { message } from 'ant-design-vue'
import FileSaver from 'file-saver'
import JSZip from 'jszip'
import { cloneDeep } from 'lodash'

import { createPaibanImg } from './util/createPaibanImg'

export default {
  name: 'paibanImg',
  components: {
    breadcrumb,
    GBaseModal,
    GPaidFeature,
    loading,
  },
  data() {
    return {
      isCustomPaibanImg: false,
      templateList: [],
      activeTemId: 1,
      defaultTem: {},
      templateData: {},
      canvasIndex: '',
      matCode: '全部',
      texture: '全部',
      thick: '全部',
      matCodeOptions: ['全部'],
      textureOptions: ['全部'],
      thickOptions: ['全部'],
      minSize: '',
      maxSize: '',
      // 记录上一次的搜索条件，避免无意义的重新加载
      lastSearchParams: {
        canvasIndex: '',
        matCode: '全部',
        texture: '全部',
        thick: '全部',
        minSize: '',
        maxSize: '',
      },
      // 标记是否已经执行过搜索，用于首次搜索判断
      hasSearched: false,
      numAutoOffset: 1,
      // 打印一张纸 最多展示多少张排版图
      onePageNum: 1,
      currentPaibanData: [],
      afterPaibanData: [],
      svgList: [],
      isLoading: false,
      loadingText: '数据正在加载中......',
      // 是否在加载模板
      isLoadTem: false,
      // 是否在加载排版图
      isLoadSvg: false,
      // 是否展示删除模板弹窗
      isShowDelModal: false,
      isExportLoad: false,
      myIframe: null,
      // 切割顺序检测错误弹窗
      isShowInspectCutOrder: false,
      // 切割顺序不正确的小板数组
      errorCutOrders: [],
      // 切割顺序不正确的大板数组
      errorBigPlankCutOrders: [],
      // 缩放
      zoomScale: 1,
      zoomMin: 0.3,
      zoomMax: 3,
      zoomStep: 0.1,
    }
  },
  computed: {
    paibanData() {
      const paibanData = this.$store.state.paibanData
      // 过滤出排版了但是仅加工孔槽的板件
      const result = paibanData.filter((v) => !v.isDesMaterialNoCut)
      return result
    },
    hasDxf2dPermission() {
      return checkUserPermissions(['DXF_2D']) === true
    },
    hasDxf3dPermission() {
      return checkUserPermissions(['DXF_3D']) === true
    },
  },
  methods: {
    // 自定义排版图 按钮 开启关闭处理
    handleChangeCustom() {
      updateLocalPreference({
        isCustomPaibanImg: this.isCustomPaibanImg,
      })
      buryPointApi('paibanImgManage', 'enable')
      this.requestData()
    },

    // 处理选中模板
    async handleSelectedTem(item) {
      this.activeTemId = item.id
      updateLocalPreference({
        paibanImgTemplateId: this.activeTemId,
      })
      const modelDataRes = await fetchModelData(this.activeTemId)
      this.templateData =
        modelDataRes.status === 1
          ? modelDataRes.data.data ?? defaultPaibanImgTemplate
          : defaultPaibanImgTemplate
      this.loadImgList()
    },

    // 处理模板勾选状态
    handleCheckedTem(e, item) {
      item.status = e.target?.checked ? 1 : 2
      changeModelChecked({ id: item.id, status: item.status })
    },

    // 添加模板
    handleAddTem() {
      if (this.templateList.length >= 10) {
        this.$message({
          message: '最多只能添加10个排版图模板！',
          type: 'warning',
        })
        return
      }
      let from = this.$route.query.from ? 'temp' : undefined
      this.$router.push({
        path: '/editPaibanImg',
        query: {
          from,
          temLength: this.templateList.length,
        },
      })
    },

    // 跳转到编辑模板
    gotoEdit(item) {
      let from = this.$route.query.from ? 'temp' : undefined
      this.$router.push({
        path: '/editPaibanImg',
        query: {
          from,
          id: item.id,
        },
      })
    },

    // 展示删除模板弹窗
    handleShowDelModal(item) {
      this.isShowDelModal = true
      this.activeTemId = item.id
    },

    // 确认删除模板
    handleConfirmDelTem() {
      delModel(this.activeTemId).then((res) => {
        if (res.status === 1) {
          this.isShowDelModal = false
          this.$message({
            duration: 1000,
            message: this.$translateLang('删除成功'),
            type: 'success',
          })
          // 删除之后 就用默认模板
          this.activeTemId = this.defaultTem.id
          updateLocalPreference({
            paibanImgTemplateId: this.activeTemId,
          })
          this.requestData()
          buryPointApi('paibanImgManage', 'del_tem')
        } else {
          this.$message({
            duration: 1000,
            message: this.$translateLang('删除失败'),
            type: 'error',
          })
        }
      })
    },

    // 限制输入为整数数字
    handleInputNumber(type) {
      this[type] = Number(this[type].replace(/[^\d]*/g, ''))
    },

    // 板件尺寸输入限制 和原片大板尺寸的限制一致 5位整数-两位小数
    handleInputSize(type) {
      this[type] = this[type].replace(/[^\d\\.]/g, '')
      this[type] = this[type].includes('.')
        ? this[type].split('.')[0].substring(0, 5) +
          '.' +
          this[type].split('.')[1].substring(0, 2)
        : this[type].substring(0, 5)
    },

    // 板件筛选
    handleSearch() {
      // 检查搜索条件是否真的改变了
      const currentParams = {
        canvasIndex: this.canvasIndex || '',
        matCode: this.matCode,
        texture: this.texture,
        thick: this.thick,
        minSize: this.minSize || '',
        maxSize: this.maxSize || '',
      }

      // 如果搜索条件没有改变且已经执行过搜索，直接返回，避免不必要的重新加载
      const isParamsChanged =
        currentParams.canvasIndex !== this.lastSearchParams.canvasIndex ||
        currentParams.matCode !== this.lastSearchParams.matCode ||
        currentParams.texture !== this.lastSearchParams.texture ||
        currentParams.thick !== this.lastSearchParams.thick ||
        currentParams.minSize !== this.lastSearchParams.minSize ||
        currentParams.maxSize !== this.lastSearchParams.maxSize

      // 首次搜索或条件改变时才执行
      if (this.hasSearched && !isParamsChanged) {
        return
      }

      // 更新上一次的搜索条件和搜索标记
      this.lastSearchParams = { ...currentParams }
      this.hasSearched = true

      let data = this.paibanData.length ? this.paibanData : defaultPaibanData
      if (this.canvasIndex) {
        this.currentPaibanData = data.filter(
          (item) => item.canvasIndex == this.canvasIndex
        )
        this.loadImgList()
      } else if (
        this.matCode !== '全部' ||
        this.texture !== '全部' ||
        this.thick !== '全部' ||
        this.minSize ||
        this.maxSize
      ) {
        const searchCondition = {
          matCode: this.matCode,
          texture: this.texture,
          thick: this.thick,
          plankWidth: this.minSize,
          plankHeight: this.maxSize,
        }
        this.currentPaibanData = data.filter((item) => {
          return Object.entries(searchCondition).every(([key, value]) => {
            if (['matCode', 'texture', 'thick'].includes(key)) {
              return value !== '全部' ? item[key] == value : true
            }
            if (['plankWidth', 'plankHeight'].includes(key)) {
              return value ? item[key] == value : true
            }
          })
        })
        this.loadImgList()
      } else {
        this.currentPaibanData = data
        this.loadImgList()
      }
    },

    async requestData() {
      if (this.isCustomPaibanImg) {
        this.isLoadTem = true
        const modelRes = await fetchModelList()
        this.templateList = modelRes.status === 1 ? modelRes.data ?? [] : []
        // 获取默认排版图
        this.defaultTem = this.templateList.find(
          (item) => item.is_default === 1
        )
        if (
          !this.templateList.map((item) => item.id).includes(this.activeTemId)
        ) {
          this.activeTemId = this.defaultTem.id
        }
        const modelDataRes = await fetchModelData(this.activeTemId)
        this.templateData =
          modelDataRes.status === 1
            ? modelDataRes.data.data ?? defaultPaibanImgTemplate
            : defaultPaibanImgTemplate
        this.isLoadTem = false
        this.initData()
      }
    },

    initData() {
      // 获取 材质、颜色、厚度 下拉框数据
      if (this.paibanData.length) {
        this.matCodeOptions = [
          '全部',
          ...this.paibanData.map((item) => item.matCode),
        ]
        this.matCodeOptions = Array.from(new Set(this.matCodeOptions))
        this.textureOptions = [
          '全部',
          ...this.paibanData.map((item) => item.texture),
        ]
        this.textureOptions = Array.from(new Set(this.textureOptions))
        this.thickOptions = [
          '全部',
          ...this.paibanData.map((item) => item.thick),
        ]
        this.thickOptions = Array.from(new Set(this.thickOptions))
        this.currentPaibanData = this.paibanData
        this.afterPaibanData = cloneDeep(this.paibanData)
      } else {
        this.currentPaibanData = defaultPaibanData
        this.afterPaibanData = cloneDeep(defaultPaibanData)
      }
      this.handleSearch()
    },

    async loadImgList(temData, isExport) {
      if (!isExport) this.isLoadSvg = true
      let templateData = temData ?? this.templateData
      let svgList = []
      if (!isExport) this.svgList = []
      let svg_html
      let chunkPaibanData = chunkArray(this.currentPaibanData, this.onePageNum)
      for (let plank of chunkPaibanData) {
        svg_html = await createPaibanImg(templateData, plank, {
          total: this.paibanData.length
            ? this.paibanData.length
            : defaultPaibanData.length,
        })
        if (!isExport) this.svgList.push(svg_html)
        svgList.push(svg_html)
      }
      this.isLoadSvg = false
      return svgList
    },

    // 修改序号补偿位
    handleChangeNumAutoOffset() {
      if (!this.numAutoOffset) this.numAutoOffset = 1
      updateLocalPreference({
        numAutoOffset: this.numAutoOffset,
      })
    },

    // 修改一张展示多少张排版图
    handleChangeOnePageNum() {
      if (!this.onePageNum) this.onePageNum = 1
      updateLocalPreference({
        onePageNum: this.onePageNum,
      })
      this.loadImgList()
    },

    // 检测切割顺序
    judgeCutOrder() {
      // 切割顺序有问题的板子数组
      this.errorCutOrders = []
      this.errorBigPlankCutOrders = []
      const paibanData = this.currentPaibanData
      for (let index = 0; index < paibanData.length; index++) {
        let flag = false
        const plank = paibanData[index]
        // 是否存在重复切割顺序
        // 是否是连续的切割顺序
        // 不能用原数组进行sort排序处理，修改原数组会触发监听，调用当前方法，无限循环
        let parts = cloneDeep(plank.parts).filter(
          (part) => !part.blueAreaSurplus
        )
        // 切割顺序错误的几种情况 a.1 1 2 3 提示板件1  b.1 2 4 5 提示板件4、5  c.1 2 2 5 6 提示板件2、5、6
        // 重复数据
        const prioritys = []
        for (let i = 0; i < plank.parts.length; i++) {
          if (prioritys.includes(plank.parts[i].priority)) {
            // 放入错误数据
            this.errorCutOrders.push(plank.parts[i])
            // 将重复数据变成null方便后期筛选
            parts[i] = null
            // 修改判断大板顺序是否有错误
            flag = true
          } else {
            prioritys.push(plank.parts[i].priority)
          }
        }
        parts = parts.filter((item) => item)
        parts.sort((a, b) => a.priority - b.priority)
        for (let i = 0; i < parts.length; i++) {
          // 切割顺序不连续数据
          if (parts[i].priority != i + 1) {
            this.errorCutOrders.push(parts[i])
            flag = true
          }
        }
        if (flag) {
          this.errorBigPlankCutOrders.push(plank.canvasIndex)
        }
      }
      this.errorBigPlankCutOrders.sort((a, b) => a - b)
      return this.errorCutOrders.length
    },

    handleGoAdjust() {
      this.isShowInspectCutOrder = false
      this.$router.push({
        path: '/newPaiban',
        query: {
          from: 'paibanImg',
        },
      })
    },

    initIframe() {
      // 创建打印专用iframe
      this.myIframe = document.createElement('iframe')
      this.myIframe.style.display = 'none'
      document.body.appendChild(this.myIframe)

      const head = this.myIframe.contentDocument.head
      // 获取父页面的所有link和style标签
      const parentLinks = window.parent.document.querySelectorAll(
        'link[rel="stylesheet"]'
      )
      const parentStyles = window.parent.document.querySelectorAll('style')

      // 复制父页面的外联样式
      parentLinks.forEach(function (link) {
        const newLink = document.createElement('link')
        newLink.rel = 'stylesheet'
        newLink.type = 'text/css'
        newLink.href = link.href
        head.appendChild(newLink)
      })

      // 复制父页面的内联样式
      parentStyles.forEach(function (style) {
        const newStyle = document.createElement('style')
        newStyle.textContent = style.textContent
        head.appendChild(newStyle)
      })
    },

    // 打印(只能打印当前选中模板排版图，不能打印勾选的多个)
    handlePrint() {
      if (this.judgeCutOrder()) {
        this.isShowInspectCutOrder = true
        return
      }
      buryPointApi('paibanImgManage', 'print')
      const currentTem = this.templateList.find(
        (item) => item.id === this.activeTemId
      )
      // 内嵌云排版
      if (typeof window.webToQt !== 'undefined') {
        webToQt.webLabelPdfToQtV2(
          {
            fileName: `${currentTem.name}.pdf`,
            imgArr: this.svgList.map((v) => {
              return v.base64.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
            }),
            tagWidth: this.templateData.width,
            tagHeight: this.templateData.height,
          },
          'print'
        )
        return
      }

      // 克隆要打印的内容
      const printContent = document.querySelector('.svg-wrap').cloneNode(true)

      // 将克隆内容插入iframe
      this.myIframe.contentDocument.body.appendChild(printContent)

      // 创建并插入打印样式
      const printStyle = document.createElement('style')
      printStyle.innerHTML = `
        @media print {
          @page {
            size: ${this.templateData.width}px ${this.templateData.height}px;
            margin: 0;
          }
        }
      `
      this.myIframe.contentDocument.head.appendChild(printStyle)

      // 触发打印
      this.myIframe.contentWindow.focus()
      this.myIframe.contentWindow.print()

      // 清理
      setTimeout(() => {
        // 清空iframe body内容
        this.myIframe.contentDocument.body.innerHTML = ''
      }, 100)
    },

    formatNumber(input, paddingValue) {
      // 获取输入的数字
      let number = parseInt(input, 10)
      // 获取补偿值
      let padding = parseInt(paddingValue, 10)
      // 计算最终补偿后的数字
      let formattedNumber = String(number).padStart(padding, '0')
      // 返回补偿后的结果
      return formattedNumber
    },

    handleExportDxf(profileId) {
      if (
        (profileId === 'general-2d-v1' && !this.hasDxf2dPermission) ||
        (profileId === 'specialized-3d-v1' && !this.hasDxf3dPermission)
      ) {
        message.warning(
          this.$translateLang('该功能为付费功能，请联系销售开通后使用~')
        )
        return
      }
      this.handleExport('dxf', profileId)
    },

    // 导出图片及pdf
    async handleExport(type, profileId) {
      if (this.judgeCutOrder()) {
        this.isShowInspectCutOrder = true
        return
      }
      // status为2 表示未被勾选
      if (this.templateList.every((item) => item.status === 2)) {
        this.$message({
          message: '请至少勾选一个排版图模板导出！',
          type: 'error',
        })
        return
      }
      buryPointApi(
        'paibanImgManage',
        `export_${type !== 'dxf' ? type : profileId}`
      )
      this.isExportLoad = true
      let zip = new JSZip()
      // 是否只有一个模板勾选
      let isOneChecked =
        this.templateList.filter((item) => item.status === 1).length === 1
      // 获取文件管理设置
      const customFolderSettingRef = await getCustomFolderSetting({
        setting_id: this.$store.state.ncSetting?.process_setting_id,
      })
      for (let item of this.templateList) {
        if (item.status === 1) {
          let temName = item.name
          let modelDataRes = await fetchModelData(item.id)
          let templateData =
            modelDataRes.status === 1
              ? modelDataRes.data.data ?? defaultPaibanImgTemplate
              : defaultPaibanImgTemplate
          let svgList = await this.loadImgList(templateData, true)
          if (type === 'pdf') {
            await jsPdfTool.loadFontByTagTemp([
              ...([{ data: templateData.bigPlank, type: 'bigPlank' }] ?? []),
              ...([{ data: templateData.part, type: 'part' }] ?? []),
            ])
            // svg直转 pdf
            const binary = await getSvgListToPdfJSBinary(
              svgList.map((svgItem) => svgItem.svg),
              {
                unit: 'mm',
                format: [templateData.width, templateData.height],
              }
            )
            // 内嵌云排版
            if (typeof window.webToQt !== 'undefined') {
              // 多个PDF不能直接 saveAs，否则会覆盖，应全部打包成zip再触发一次下载
              if (!this._pdfZip) {
                this._pdfZip = new JSZip()
              }
              this._pdfZip.file(`${item.name}.pdf`, new Blob([binary]), {
                binary: true,
              })
              // 检查是否已是最后一个导出项，如果是则生成并下载zip
              const selectedPdfTemplates = this.templateList.filter(
                (it) => it.status === 1 && type === 'pdf'
              )
              if (
                selectedPdfTemplates[selectedPdfTemplates.length - 1] === item
              ) {
                this._pdfZip.generateAsync({ type: 'blob' }).then((content) => {
                  FileSaver.saveAs(content, `排版图.zip`)
                  this._pdfZip = null // 清理
                })
              }
            } else {
              zip.file(`${temName}.pdf`, new Blob([binary]), { binary: true })
            }
          } else if (type === 'img') {
            let base64Arr = svgList.map((svgItem) => svgItem.base64)
            let qtImgArr = []
            let originFileName = ''
            // 勾选了文件管理排版图
            if (
              customFolderSettingRef?.data?.required_folders?.includes(
                'paibanImg_folder'
              )
            ) {
              originFileName = `${this.$store.state.ncSetting.customizeFolder?.paibanImg_folder}/`
            }
            originFileName += `${temName}/`
            for (let [i, it] of base64Arr.entries()) {
              let base64 = it.split(',')[1]
              if (templateData.imageFormat === 'bmp') {
                const newBase64 = await convertJpegToBmp.convertJpegToBmp(it)
                base64 = newBase64.split(',')[1]
              }
              // 根据序号补偿位计算结果
              let formatOrder = this.formatNumber(i + 1, this.numAutoOffset)
              let fileNamePrefix = templateData.imageNamePrefix
              if (templateData.bigPlank.isCustomName) {
                fileNamePrefix = svgList[i].customNameText
                const labelKeys = Object.values(
                  templateData.bigPlank.customName.label_keys
                )
                // 添加大板序号数据源后 默认排版图序号就不需要生成
                if (labelKeys.includes('canvasIndex')) {
                  formatOrder = ''
                }
              }
              let fileName = `${fileNamePrefix}${formatOrder}.${templateData.imageFormat}`
              zip.file(`${originFileName}${fileName}`, base64, { base64: true })
              qtImgArr.push({
                url: base64,
                fileName: fileName,
              })
            }
            // 内嵌云排版
            if (typeof window.webToQt !== 'undefined') {
              window.webToQt.webLabelImgToQt({
                tagWidth: templateData.width,
                tagHeight: templateData.height,
                imgArr: qtImgArr,
                originFileName: temName,
              })
            }
          } else if (type === 'dxf') {
            let originFileName = ''
            if (
              customFolderSettingRef?.data?.required_folders?.includes(
                'paibanImg_folder'
              )
            ) {
              originFileName = `${this.$store.state.ncSetting.customizeFolder?.paibanImg_folder}/`
            }
            const fileNames = svgList.map((svgItem, index) => {
              const isCustomName = templateData.bigPlank.isCustomName
              const fileNamePrefix = isCustomName
                ? svgItem.customNameText
                : templateData.imageNamePrefix
              const fileNameOrder = isCustomName
                ? ''
                : this.formatNumber(index + 1, this.numAutoOffset)
              return `${fileNamePrefix}${fileNameOrder}.dxf`
            })
            await exportPaibanImgDxf(templateData, this.currentPaibanData, {
              folderName: `${originFileName}${temName}`,
              fileNames,
              onePageNum: this.onePageNum,
              total: this.paibanData.length
                ? this.paibanData.length
                : defaultPaibanData.length,
              zip,
              save: false,
              profileId: type === 'dxf' ? profileId : undefined,
            })
          }
        }
      }
      if (type === 'dxf' || typeof window.webToQt == 'undefined') {
        zip.generateAsync({ type: 'blob' }).then((content) => {
          let firstName = type === 'dxf' ? '排版图DXF' : '排版图'
          FileSaver.saveAs(content, `${firstName}.zip`)
        })
      }
      this.isExportLoad = false
    },
    // 处理缩放
    handleZoom(event) {
      if (!event.ctrlKey) return
      event.preventDefault()

      const delta = event.deltaY
      if (delta > 0) {
        this.zoomScale = Math.max(this.zoomMin, this.zoomScale - this.zoomStep)
      } else {
        this.zoomScale = Math.min(this.zoomMax, this.zoomScale + this.zoomStep)
      }
    },
  },
  mounted() {
    this.isLoading = true
    this.afterPaibanData = this.paibanData.length
      ? cloneDeep(this.paibanData)
      : cloneDeep(defaultPaibanData)
    getPreferencesSetting(
      window.sessionStorage.getItem('thinkerx_material'),
      this.$store.state.userInfo.platform
    ).then(async (res) => {
      await initFabricNeedFont()
      this.initIframe()
      this.isLoading = false
      this.isCustomPaibanImg = res.data.isCustomPaibanImg
      this.activeTemId = res.data.paibanImgTemplateId
      this.numAutoOffset = res.data.numAutoOffset
      this.onePageNum = res.data.onePageNum
      this.requestData()
      // 监听缩放事件
      this.$nextTick(() => {
        const svgWrap = this.$refs.svgWrap
        if (svgWrap) {
          svgWrap.addEventListener('wheel', this.handleZoom, { passive: false })
        }
      })
    })
  },
  activated() {
    const paibanData = this.paibanData.length
      ? this.paibanData
      : defaultPaibanData
    const ignoreKeys = ['isActive', 'isLocked', '_sortNum']
    const replacer = (key, value) =>
      ignoreKeys.includes(key) ? undefined : value

    if (
      JSON.stringify(this.afterPaibanData, replacer) !==
      JSON.stringify(paibanData, replacer)
    ) {
      // 重置搜索标记，确保排版数据变化时强制重新加载svg
      this.hasSearched = false
      this.initData()
    }
  },
  // 模板编辑退出刷新页面
  beforeRouteEnter(to, from, next) {
    if (from.name == 'editPaibanImg') {
      next((vm) => {
        vm.requestData()
      })
    }
    next(true)
  },
  beforeDestroy() {
    const svgWrap = this.$refs.svgWrap
    if (svgWrap) {
      svgWrap.removeEventListener('wheel', this.handleZoom)
    }
  },
}
</script>

<style lang="less" scoped>
.paiban-img {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    height: 8px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    background-color: #eee;
    border-radius: 10px;
  }
  min-height: calc(100vh - 60px);
  /deep/.breadcrumb-box {
    position: relative;
    z-index: 1;
    height: 46px;
    padding: 0 !important;
    .bread-crumb-box {
      display: flex;
      align-items: center;
      height: 46px !important;
      background-color: #eee !important;
      .ant-breadcrumb {
        margin-top: 2px !important;
        padding: 0 !important;
        padding-left: 16px !important;
      }
    }
    .bread-crumb-box .bread-crumb-box-content {
      display: none !important;
    }
    .select-tag {
      position: absolute;
      bottom: 10px;
      left: 320px;
      display: flex;
      align-items: center;

      .el-icon-loading {
        margin-left: 5px;
        color: #18a8c7;
        font-size: 16px;
      }

      .progress {
        display: block;
        width: 180px;
        margin-left: 5px;
      }
    }
  }
  .title {
    color: rgba(0, 0, 0, 0.9);
    font-weight: 500;
  }
  .custom-btn {
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .paiban-img-content {
    display: flex;
    min-height: calc(100vh - 153px);
    .left {
      width: 280px;
      background-color: #fff;
      .template {
        padding: 15px 17px 15px 14px;
        .add-tem {
          color: #18a8c7;
          cursor: pointer;
        }
        .template-list {
          height: 130px;
          margin-top: 12px;
          overflow-x: hidden;
          overflow-y: auto;
          .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 248px;
            height: 32px;
            padding-right: 12px;
            padding-left: 8px;
            .name {
              width: 160px;
              padding-left: 8px;
              overflow: hidden;
              color: rgba(0, 0, 0, 0.9);
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .iconfont {
              cursor: pointer;
            }
            &:hover {
              background-color: #f3f3f3;
              border-radius: 3px;
            }
          }
          .active-item {
            background-color: #f3f3f3;
            border-radius: 3px;
          }
        }
      }
      .setting-search {
        padding: 15px 17px 15px 14px;
        border-top: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
        &-item {
          margin-top: 16px;
          .line {
            padding: 0 14px;
            color: #d9d9d9;
          }
        }
      }
      .setting-other {
        padding: 15px 17px 10px 14px;
      }
    }
    .right {
      flex: 1;
      overflow: hidden;
      background-color: #f5f5f5;
      .head {
        padding: 20px 20px 0 0;
        font-weight: 500;
        text-align: right;
        .symbol {
          max-width: 80px;
          color: #18a8c7;
          cursor: pointer;
        }
        .print-btn {
          margin-right: 16px;
          margin-left: 24px;
        }
        .print-btn:not([disabled='disabled']) {
          color: rgba(0, 0, 0, 0.9);
        }
        .export-btn:not([disabled='disabled']) {
          color: #fff;
          background-color: #18a8c7;
          border: none;
        }
        .dxf-export-trigger {
          position: relative;
          display: inline-block;
          vertical-align: middle;

          .dxf-export-crown {
            position: absolute;
            top: -8px;
            right: -4px;
            z-index: 2;
            color: #f4d086;
            font-size: 14px;
            line-height: 1;
            pointer-events: none;
          }
        }
      }
      .svg-wrap {
        height: calc(100vh - 205px);
        padding: 20px 20px 0 20px;
        overflow: auto;
        text-align: center;
        .svg-scale-container {
          display: inline-block;
        }
        &-item {
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>

<style lang="less">
.paiban-img-symbol {
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner-content {
    width: 146px;
    height: 146px;
    padding: 12px 14px 10px 14px;
  }
  .symbol-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .slot-img {
    width: 60px;
    height: 8px;
    margin-right: 16px;
    border: 1px solid #000;
  }
  .slot-img.back {
    border-width: 2px;
  }
  .hole-img {
    width: 12px;
    height: 12px;
    margin-right: 40px;
    margin-left: 24px;
    border: 1px solid #000;
    border-radius: 50%;
  }
  .hole-img.back {
    border-width: 2px;
  }
}

.paiban-img-dxf-export {
  .ant-popover-inner-content {
    padding: 8px;
  }

  .dxf-export-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 180px;
  }

  .dxf-export-option-wrap {
    display: block;
  }

  .dxf-export-option {
    width: 100%;
    text-align: left;
  }
}
</style>
